export type QueueDoNotDisturb = 'ENABLED' | 'DISABLED';

type QueueDoNotDisturbFields = {
  doNotDisturb?: QueueDoNotDisturb;
  do_not_disturb?: QueueDoNotDisturb;
};

/**
 * Reads the queue's Do Not Disturb flag from `GET /v1/dialing-queues/current`.
 *
 * The backend may send either casing (`doNotDisturb` / `do_not_disturb`), so we
 * read both and default to `DISABLED` when the column is absent — i.e. a session
 * only forces the user into busy mode when the queue explicitly asks for it.
 */
export const resolveQueueDoNotDisturb = (
  queue: QueueDoNotDisturbFields | null | undefined,
): QueueDoNotDisturb => queue?.doNotDisturb ?? queue?.do_not_disturb ?? 'DISABLED';
